const formateNumber = (number, removeDecimal = false) => {
  if (typeof number === 'string' && number.indexOf('%') === number.length - 1) return number;

  const formatWithoutDecimals = num =>
    num.toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  if (typeof number === 'string') {
    const numericValue = parseFloat(number.replace(',', '.'));

    // Если нужно удалить дробную часть
    if (removeDecimal) {
      return formatWithoutDecimals(numericValue);
    }

    if (numericValue >= 1000000000) {
      return formatWithoutDecimals(numericValue);
    }

    if (Number.isInteger(numericValue)) {
      return numericValue.toLocaleString('de-DE', {
        minimumFractionDigits: 0, // Изменяем минимальное количество десятичных знаков на 0
        maximumFractionDigits: 2,
      });
    }

    return numericValue.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else if (typeof number === 'number') {
    if (removeDecimal) {
      return formatWithoutDecimals(number);
    }

    if (number >= 1000000000) {
      return formatWithoutDecimals(number);
    }

    if (Number.isInteger(number)) {
      return number.toLocaleString('de-DE', {
        minimumFractionDigits: 0, // Изменяем минимальное количество десятичных знаков на 0
        maximumFractionDigits: 2,
      });
    }
    return number.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return number;
};

export const reformatNumber = number => {
  return number.replaceAll('.', '').replaceAll(',', '.');
};

export default formateNumber;
